<template>
  <div :class="bem()">
    <span :class="bem('wrapper')">
      <span :class="bem('out-of-5')">{{ $tn(rating || 0, 1) }}</span>
      <VisionStarRating
        :rating="props.rating"
        colour="gradient"
      />
    </span>
    <span>
      <span :class="bem('total')">({{ formattedReviewCount }})</span>
    </span>
  </div>
</template>

<script setup lang="ts">
interface ProductReviewStarsProps {
  rating: number
  count: number
}

const props = withDefaults(defineProps<ProductReviewStarsProps>(), {
  rating: 0,
  count: 0,
})

const bem = useBEM('ProductReviewStars')

const formattedReviewCount = computed(() => {
  return new Intl.NumberFormat().format(props.count)
})
</script>

<style lang="postcss" scoped>
.ProductReviewStars {
  @apply flex flex-col items-end
    text-xxs leading-none
    mt-2;
}

.ProductReviewStars__wrapper {
  @apply flex items-center;
}

.ProductReviewStars__count {
  @apply font-bold;
}

.ProductReviewStars__total {
  @apply text-xxs text-grey-500 font-fragment-mono;
}

.ProductReviewStars__out-of-5 {
  @apply font-semibold ml-1 mr-1;
}
</style>
